/**
 * @docs docs/features/opportunities
 * @adr  ADR-0074
 * @rule The latest published edition of either page (`/business-ideas`, `/trending-domains`), with the pending banner before 06:00 UTC. Never static: the latest edition flips at 06:00 UTC.
 */

import { definePageRoute } from '@common/router/definitions';

import { buildEditionsRouteData, renderEditionsRoute } from './lib/editionsRoute';

export default definePageRoute({
    path: '/:editionPage(business-ideas|trending-domains)',
    options: { auth: false, layout: false },
    data: buildEditionsRouteData,
    render: renderEditionsRoute,
});
